import {
  Button,
  Col,
  Form,
  Row,
  Select,
  Space,
  Table,
  Tag,
  Typography,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { PlusCircleOutlined } from '@ant-design/icons';
import IntlMessage from '../../components/IntlMessage';
import dayjs from 'dayjs';
import useTime from '../../hooks/useTime';
import _ from 'lodash';
import reportApi from '../../api/report';
import ModalPassengers from './ModalPassengers';
import ModalRoute from './ModalRoute';
import { useHistory } from 'react-router-dom';

const { Text } = Typography;

const Route = (props) => {
  console.log('props', props);
  const [form] = Form.useForm();
  const { formatAsISOString } = useTime();
  const [filter, setFilter] = useState({
    keyword: '',
    date_mode: 'date',
    filter_name: [],
    filter_value: [],
    // from_date: dayjs().startOf('month').toISOString(),
    // to_date: dayjs().endOf('month').toISOString(),
  });
  const [dataChart, setDataChart] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [destinations, setDestinations] = useState([]);
  const [search, setSearch] = useState(false);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState({
    yobuma: 0,
    cashier: 0,
    filling_rate: 0,
    pass_cashier: 0,
    pass_yobuma: 0,
  });
  const [mode, setMode] = useState('date');
  const [modalPass, setModalPass] = useState(false);
  const [modalRoute, setModalRoute] = useState(false);
  const [item, setItem] = useState({});
  const [condition, setCondition] = useState({});
  const history = useHistory();

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        filter.filter_name = [...filter?.filter_name, 'operator_id'];
        filter.filter_value = [...filter?.filter_value, props.operator_id];

        Promise.all([
          reportApi.getAllRoutes(filter),
          reportApi.getDesByOperator(props.operator_id),
          // destinationsApi.getAll(filter),
        ]).then((res) => {
          if (res[0]) {
            setDataTable(res[0]?.data);
            setDataChart(res[0]?.data_revenue);
            setTotal({
              yobuma: res[0]?.yobuma,
              cashier: res[0]?.cashier,
              filling_rate: Number(res[0]?.filling_rate),
              pass_cashier: res[0]?.pass_cashier,
              pass_yobuma: res[0]?.pass_yobuma,
            });
            setDestinations(res[0].data_destination);
          }
          if (Array.isArray(res[1])) {
            setDestinations(res[1]);
          }

          setLoading(false);
        });
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    }

    props.operator_id && fetchData();
  }, [search, props.operator_id]);

  // useEffect(() => {
  //   async function fetchData() {
  //     try {
  //       const payload = {
  //         limit: 999,
  //         page: 1,
  //         order_by: 'title',
  //         order_dir: 'ASC',
  //       };
  //       const res = await destinationsApi.getAll(payload);
  //       setDestinations(res?.data);
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   }

  //   fetchData();
  // }, []);

  useEffect(() => {
    if (filter?.filter_name && filter?.filter_value) {
      const newCondition = _.zipObject(
        filter?.filter_name,
        filter?.filter_value,
      );
      setCondition(newCondition);
    }
  }, [filter]);

  const onSearch = () => {
    form.validateFields().then((values) => {
      setFilter((item) => {
        return {
          ...item,
          // keyword: values?.keyword,
          date_mode: mode,
          // from_date:
          //   mode === 'date'
          //     ? values.from_date?.toISOString()
          //     : values.from_date?.startOf(mode).toISOString(),
          // to_date:
          //   mode === 'date'
          //     ? values.to_date?.toISOString()
          //     : values.from_date?.endOf(mode)?.toISOString(),
          from: values?.from_dest,
        };
      });
      setSearch((e) => !e);
    });
  };

  const onChangeMode = (value) => {
    setMode(value);
    // setFilter({
    //   mode: value,
    //   from_date: dayjs().startOf(value).toISOString(),
    //   to_date: dayjs().endOf(value).toISOString(),
    // });
    form.setFieldsValue({
      from_date: mode === 'date' ? dayjs().startOf('M') : dayjs(),
      to_date: mode === 'date' ? dayjs().endOf('M') : dayjs(),
    });
  };

  const onModalPass = (record) => {
    setItem(record);
    setModalPass(true);
  };

  const onCloseModalPass = () => {
    setModalPass(false);
  };

  const onOpenRoute = (record) => {
    setItem(record);
    setModalRoute(true);
  };

  const onCloseRoute = () => {
    setModalRoute(false);
  };

  const changeDestination = (value, title) => {
    const filter_obj = { ...condition, [title]: value };
    let filter_name = [];
    let filter_value = [];
    for (var key in filter_obj) {
      if (filter_obj[key]) {
        filter_name.push(key);
        filter_value.push(filter_obj[key]);
      }
    }
    setFilter((filter) => {
      return {
        ...filter,
        filter_name: filter_name,
        filter_value: filter_value,
      };
    });
  };

  const columns = [
    {
      key: 'status',
      title: <IntlMessage id="global.status" />,
      width: 100,
      render: (text, record) => {
        return record?.status === 0 ? (
          <Tag
            color={'#2db7f5'}
            style={{ minWidth: '90px', textAlign: 'center' }}>
            <IntlMessage id={`global.inactive`} />
          </Tag>
        ) : (
          <Tag
            color={'#87d068'}
            style={{ minWidth: '90px', textAlign: 'center' }}>
            <IntlMessage id={`global.active`} />
          </Tag>
        );
      },
    },
    {
      key: 'code',
      title: <IntlMessage id="global.route_code" />,
      fixed: 'left',
      render: (text, record) => {
        return (
          <>
            <Text>
              {record?.start_location?.title} ~ {record?.end_location?.title}
            </Text>
            <Button type="link" onClick={() => onOpenRoute(record)}>
              <PlusCircleOutlined />
            </Button>
            <br />
            <Text>{record?.sku}</Text>
          </>
        );
      },
    },

    {
      key: 'depart_time',
      title: <IntlMessage id="global.depart_time" />,
      render: (text, record) => {
        return record?.segments.reduce(
          (min, current) =>
            current.start_time < min ? current.start_time : min,
          record.segments[0].start_time,
        );
      },
    },
    {
      key: 'arrival_time',
      title: <IntlMessage id="global.arrival_time" />,
      render: (text, record) => {
        return record?.segments.reduce(
          (max, current) => (current.end_time > max ? current.end_time : max),
          record.segments[0].end_time,
        );
      },
    },
    {
      key: 'arrival_time',
      title: <IntlMessage id="global.current_price" />,
      render: (text, record) => {
        return (
          record?.segments.reduce(
            (min, current) =>
              current.min_price < min ? current.min_price : min,
            record.segments[0].from_price,
          ) || 'N/A'
        );
      },
    },
    {
      key: 'code',
      title: <IntlMessage id="global.bus" />,
      render: (text, record) => {
        return (
          <>
            <Text>{record?.seatmap?.title}</Text>
          </>
        );
      },
    },
    // {
    //   key: 'code',
    //   title: <IntlMessage id="global.bus_type" />,
    //   render: (text, record) => {
    //     return <>{record?.seatmap?.status ? '1' : '0'}</>;
    //   },
    // },
    // {
    //   key: 'passenger_yobuma',
    //   title: '#yobuma',
    //   render: (text, record) => {
    //     return formatNumber(record?.pass_yobuma);
    //   },
    // },
    // {
    //   key: 'yobuma',
    //   title: <IntlMessage id="global.yobuma" />,
    //   render: (text, record) => {
    //     return formatCurrency(record?.yobuma);
    //   },
    // },
    // {
    //   key: 'passenger_cashier',
    //   title: '#cashier',
    //   render: (text, record) => {
    //     return formatNumber(record?.pass_cashier);
    //   },
    // },
    // {
    //   key: 'cashier',
    //   title: <IntlMessage id="global.cashier" />,
    //   render: (text, record) => {
    //     return formatCurrency(record?.cashier);
    //   },
    // },
    // {
    //   key: 'total_pass',
    //   title: '#',
    //   render: (text, record) => {
    //     return formatNumber(record?.pass_cashier + record?.pass_yobuma);
    //   },
    // },
    // {
    //   key: 'total',
    //   title: <IntlMessage id="global.total" />,
    //   render: (text, record) => {
    //     return formatCurrency(record?.cashier + record?.yobuma);
    //   },
    // },
    {
      key: 'passengers',
      title: <IntlMessage id="global.passengers" />,
      render: (text, record) => {
        return (
          <Button
            type="primary"
            onClick={() =>
              window.open(`/app/passenger-route/${record.id}`, '_blank')
            }>
            <IntlMessage id="global.passengers" />
          </Button>
        );
      },
    },
  ];

  return (
    <Space style={{ width: '100%' }} direction="vertical" size={6}>
      <>
        <Row>
          <Col>
            <Form layout="inline" form={form} onFinish={onSearch}>
              {/* <Form.Item name={'keyword'}>
            <Input placeholder="Search..." />
          </Form.Item> */}
              <Form.Item name={'from'}>
                <Select
                  showSearch
                  placeholder={'Départ'}
                  allowClear={true}
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    return (
                      option?.children
                        ?.toLowerCase()
                        ?.indexOf(input?.toLowerCase()) >= 0
                    );
                  }}
                  onChange={(value) => changeDestination(value, 'from')}>
                  {destinations?.map((item) => {
                    return (
                      <Select.Option key={item.id} value={item.id}>
                        {item?.title}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item name={'to'}>
                <Select
                  showSearch
                  placeholder={'Arrivée'}
                  allowClear={true}
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    return (
                      option?.children
                        ?.toLowerCase()
                        ?.indexOf(input?.toLowerCase()) >= 0
                    );
                  }}
                  onChange={(value) => changeDestination(value, 'to')}>
                  {destinations?.map((item) => {
                    return (
                      <Select.Option key={item.id} value={item.id}>
                        {item?.title}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Row justify={'start'}>
                {/* <Col>
                  <Radio.Group
                    name="date_type"
                    onChange={(e) =>
                      onFilter(e.target.value, e.target.name, '')
                    }
                    defaultValue={dataDateType[0].value}>
                    <Flex vertical>
                      {dataDateType?.map((item, index) => {
                        return (
                          <Radio key={index} value={item?.value}>
                            {item?.label}
                          </Radio>
                        );
                      })}
                    </Flex>
                  </Radio.Group>
                </Col> */}
                {/* <Col>
                  <Form.Item
                    name={'mode'}
                    initialValue={'date'}
                    rules={[
                      {
                        required: true,
                        message: <IntlMessage id="global.requiredfeild" />,
                      },
                    ]}>
                    <Select
                      placeholder="Select mode"
                      onSelect={onChangeMode}
                      options={[
                        {
                          value: 'date',
                          label: <IntlMessage id="global.date" />,
                        },
                        {
                          value: 'month',
                          label: <IntlMessage id="global.month" />,
                        },
                        {
                          value: 'day',
                          label: <IntlMessage id="global.day" />,
                        },
                      ]}></Select>
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name="from_date"
                    initialValue={dayjs().startOf('M')}
                    dependencies={['mode', 'to_date']}
                    rules={[
                      {
                        required: false,
                        message: <IntlMessage id="global.requiredfeild" />,
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (getFieldValue('mode')) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error('Please select mode!!')
                          );
                        },
                      }),
                    ]}>
                    <DatePicker
                      placeholder="From"
                      format={'DD-MM-YYYY'}
                      picker={mode}
                    />
                  </Form.Item>
                </Col>
                {mode === 'date' && (
                  <Col>
                    <Form.Item
                      name="to_date"
                      initialValue={dayjs().endOf('M')}
                      dependencies={['mode', 'from_date']}
                      rules={[
                        {
                          required: false,
                          message: <IntlMessage id="global.requiredfeild" />,
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (
                              (value && getFieldValue('from_date')) ||
                              !getFieldValue('from_date')
                            ) {
                              return Promise.resolve();
                            }

                            return Promise.reject(
                              new Error('Please select from date!!')
                            );
                          },
                        }),
                      ]}>
                      <DatePicker
                        placeholder="To"
                        format={'DD-MM-YYYY'}
                        picker={mode}
                      />
                    </Form.Item>
                  </Col>
                )} */}
                <Col>
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Filtrer
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
        <br />

        <Table
          dataSource={dataTable}
          columns={columns}
          tableLayout="auto"
          loading={loading}
          bordered
          scroll={{ x: 'max-content' }}
          rowKey="id"
          size="small"
        />
      </>
      {modalPass && (
        <ModalPassengers
          open={modalPass}
          onClose={onCloseModalPass}
          item={item}
          date_from={filter.from_date}
          date_to={filter.to_date}
        />
      )}
      {modalRoute && (
        <ModalRoute
          open={modalRoute}
          onClose={onCloseRoute}
          data={dataTable}
          item={item}
        />
      )}
    </Space>
  );
};

export default Route;
